import React from 'react';
import { BryButton } from './BryButton';

export const BryEmptyState = ({
  icon: Icon,
  title = 'No hay información disponible',
  description = 'Aún no existen registros en esta sección.',
  actionLabel,
  onAction,
  actionIcon,
  className = '',
  iconClassName = '',
  titleClassName = '',
  descriptionClassName = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center p-8 rounded-2xl ${className}`.trim()}>
      {Icon && (
        <div className={`w-20 h-20 rounded-full flex justify-center items-center mb-5 ${iconClassName || 'bg-[#E6F8F9] text-[var(--bry-accent)]'}`}>
          <Icon size={36} />
        </div>
      )}
      <h4 className={`font-bold text-lg mb-2 ${titleClassName || 'text-gray-900'}`}>{title}</h4>
      {description && <p className={`text-sm mb-6 ${descriptionClassName || 'text-gray-500'}`}>{description}</p>}
      {actionLabel && onAction && (
        <BryButton variant="primary" icon={actionIcon} onClick={onAction}>
          {actionLabel}
        </BryButton>
      )}
    </div>
  );
};
